import { render } from "preact";
import { user } from "../services/User";
import { Router, Route } from "preact-router";
import { Logo } from "../widgets/Logo";
import User from "./User";
import { effect } from "@preact/signals";
import { HomeConnect } from "@component/account";
import { accountApi } from "../lib/AccountApi";

const params = new URLSearchParams(document.location.search);
const redirect = params.get("redirect");

effect(() => {
  if (user.value) {
    window.location.href = redirect ?? "/delivery";
  }
});

const Wrapper = () => (
  <div class="theme-blue w-full min-h-full col justify-center items-center">
    <div class="col md:row w-[min(600px,80%)]">
      <div class="col bg-slate-200 md:rounded-l-lg">
        <a
          href={window.location.origin}
          title="VIA"
          class="w-20 row aspect-square items-center justify-center m-2 hover:bg-slate-50 rounded-full"
        >
          <Logo />
        </a>
      </div>
      <div class="bg-white flex-1 md:rounded-r-lg shadow-2xl col p-5 gap-5">
        <HomeConnect
          user={user.value ?? null}
          api={{
            ...accountApi,
            login: (body) =>
              accountApi.login(body).then(async (e) => {
                window.location.assign("/delivery/new");
                return e;
              }),
            register: (body) =>
              accountApi.register(body).then(async (e) => {
                await accountApi.login({
                  email: body.email,
                  password: body.password,
                });
                window.location.assign("/delivery/new");
                return e;
              }),
          }}
          links={{
            Login: "/login",
            ChangePassword: "/changePassword",
            ForgotPassword: "/forgotPassword",
            ResetPassword: "/resetPassword",
            Register: "/register",
            Settings: "/settings",
            AllCommands: "/delivery",
            NewCommand: "/delivery/new",
          }}
        />
      </div>
    </div>
  </div>
);

render(<Wrapper />, document.getElementById("root")!);
